import { styled, Typography } from '@material-ui/core';
import { Link } from 'react-router';

import { down } from '../../assets/style/breakpointHelpers';
import { domTag } from './styledFilter';

export const Separator = styled(domTag('div', ['customwidth', 'customheight']))(
	({ customwidth, customheight }: { customheight?: number | string; customwidth?: number | string }) => ({
		margin: '7px 0',
		width: customwidth || 0,
		background: 'var(--color-border-subtle)',
		height: customheight || 0,
	})
);

export const HeaderBodyText = styled(Typography)({
	fontFamily: 'var(--font-family-semibold)',
	textTransform: 'capitalize',
	fontSize: 'var(--text-h3-size)',
	lineHeight: 'var(--leading-tight)',
	margin: 0,
	marginRight: 25,
	color: 'var(--color-brand-primary)',
	[down('md')]: {
		fontSize: 'var(--text-h5-size)',
	},
});

export const HeaderContainer = styled('div')({
	display: 'flex',
	alignItems: 'center',
	marginBottom: 20,
});

export const HeaderTextNumbers = styled(Typography)({
	fontFamily: 'var(--font-family-medium)',
	textTransform: 'capitalize',
	fontSize: 'var(--text-body-size)',
	lineHeight: 'var(--leading-normal)',
	margin: 0,
	color: 'var(--color-brand-primary)',
	width: 'max-content',
	height: 'max-content',
	background: 'var(--color-brand-primary-light)',
	borderRadius: 3,
	display: 'flex',
	alignItems: 'center',
	justifyContent: 'center',
	padding: '0 8px',
});

export const LinkContainer = styled(domTag(Link, ['nodecorator']))(({ nodecorator }: { nodecorator?: 'true' | 'false' }) => ({
	'fontFamily': 'inherit',
	'fontSize': 'inherit',
	'color': 'inherit',
	'display': 'flex',
	'textDecoration': 'none',
	'&:hover': {
		color: 'inherit',
		textDecoration: nodecorator === 'true' ? 'none' : 'underline',
	},
}));
